import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { putStoreUsersStoreConfig } from '../../../services/StoreUsers/PostStoreUsers';

const StoreUserStatusChange = ({ status, editData, sendDataToStoreConfig, brandId }) => {
  const [statusValue, setStatusValue] = useState(status === 'ACTIVE');

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    const updatedData = {
      store: {
        id: editData.store.id,
      },
      userId: editData.userId,
      status: newStatus ? 'ACTIVE' : 'DEACTIVE',
      id: editData.id,
    };

    putStoreUsersStoreConfig(brandId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          sendDataToStoreConfig({
            success: true,
          });
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  return (
    <div style={{ margin: '10px 0 10px 5px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: '15px',
          width: '100%',
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default StoreUserStatusChange;
